/**
 * Statement of Work API field mapping (POST /sow, PUT /sow/:id).
 * API expects outerDiameterInch, wallThicknessMm, expectedPipeLength as numbers when set.
 *
 * numberOfPipes (request/response camelCase) — count of pipes for the section.
 * Backend may also accept/store number_of_pipes (snake_case).
 */

const trimOrUndef = (v) => {
  if (v === undefined || v === null) return undefined;
  const s = String(v).trim();
  return s === '' ? undefined : s;
};

const toOptionalFiniteNumber = (v) => {
  const t = trimOrUndef(v);
  if (t === undefined) return undefined;
  const n = Number(t);
  return Number.isFinite(n) ? n : undefined;
};

/**
 * @returns {Record<string, number>} only keys with valid numeric values
 */
export function buildSowMeasurementApiFields(odInches, wallThicknessMm, expectedPipeLength) {
  const out = {};
  const od = toOptionalFiniteNumber(odInches);
  if (od !== undefined) out.outerDiameterInch = od;
  const wt = toOptionalFiniteNumber(wallThicknessMm);
  if (wt !== undefined) out.wallThicknessMm = wt;
  const el = toOptionalFiniteNumber(expectedPipeLength);
  if (el !== undefined) out.expectedPipeLength = el;
  return out;
}

/** Normalize one SOW record from API so UI can keep using odInches. */
export function normalizeSowRecordFromApi(item) {
  if (!item || typeof item !== 'object' || Array.isArray(item)) return item;
  const next = { ...item };
  if (next.outerDiameterInch !== undefined && next.outerDiameterInch !== null && next.odInches === undefined) {
    next.odInches = next.outerDiameterInch;
  }
  if (next.number_of_pipes !== undefined && next.number_of_pipes !== null && next.numberOfPipes === undefined) {
    next.numberOfPipes = next.number_of_pipes;
  }
  return next;
}

/** Optional integer count of pipes — omit from payload when empty. */
export function toOptionalNumberOfPipes(value) {
  const n = toOptionalFiniteNumber(value);
  if (n === undefined) return undefined;
  const int = Math.round(n);
  return int >= 0 ? int : undefined;
}
